import { useApiInfiniteQuery, type Api } from "../../../services/api";

const limit = 20;

export type SearchPlaylistItem =
  Api["get"]["/webapp/public/playlists/search"]["output"]["body"]["docs"][number];

export function useSearchPlaylistsQuery(
  searchValue: string,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const trimmed = searchValue.trim();
  const isEnabled = enabled && trimmed.length > 0;

  const query = useApiInfiniteQuery(
    "/webapp/public/playlists/search",
    isEnabled
      ? { query: { limit, search: trimmed, meshResolver: true } }
      : false
  );

  return {
    playlists: query.state === "success" ? query.docs : [],
    total: query.state === "success" ? (query.total ?? 0) : 0,
    isLoading: query.state === "pending",
    isFetching: query.state === "idle" ? false : query.isFetching,
    hasNextPage: query.state === "success" && query.hasNextPage,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
  };
}
